import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import aboutimg from "../image/dharajbanner.jpg";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    comment: "",
    terms: false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Email is invalid";
    if (!formData.phone) newErrors.phone = "Phone number is required";
    if (!formData.comment) newErrors.comment = "Comment is required";
    if (!formData.terms) newErrors.terms = "You must agree to the terms";
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      alert("Form submitted successfully!");
      console.log("Submitted:", formData);
      setFormData({
        name: "",
        email: "",
        phone: "",
        comment: "",
        terms: false,
      });
      setErrors({});
    } else {
      setErrors(validationErrors);
    }
  };

  const styles = {
    section: {
      background: "#f0f4f3",
      fontFamily: "'Montserrat', sans-serif",
      padding: "30px 20px 60px 20px", // fixed: NO TOP PADDING
    },
    container: {
      maxWidth: "1200px",
      width: "100%",
      margin: "0 auto",
      marginTop:"50px",
      display: "flex",
      gap: "40px",
      flexWrap: "wrap",
    },
    column: {
      flex: "1 1 400px",
      minWidth: "300px",
    },
    label: {
      fontWeight: 500,
      color: "#222",
      marginBottom: "4px",
    },
    value: {
      color: "#333",
      marginBottom: "15px",
      display: "block",
    },
    link: {
      color: "#0066cc",
      textDecoration: "underline",
    },
    input: {
      width: "100%",
      padding: "12px",
      marginBottom: "12px",
      borderRadius: "6px",
      border: "1px solid #ccc",
    },
    textarea: {
      width: "100%",
      padding: "12px",
      marginBottom: "12px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      resize: "vertical",
    },
    checkboxLabel: {
      display: "block",
      marginBottom: "12px",
      color: "#333",
    },
    checkbox: {
      marginRight: "8px",
    },
    button: {
      background: "#222",
      color: "#fff",
      border: "none",
      padding: "12px 32px",
      borderRadius: "5px",
      cursor: "pointer",
      marginTop: "10px",
    },
    error: {
      color: "red",
      marginBottom: "10px",
      textAlign: "left",
    },
    infoGroup: {
      marginBottom: "15px",
    },
  };

  return (
    <div>

      {/* ⭐ HERO SECTION — NO GAP FROM TOP/LEFT/RIGHT */}
      <section
        className="position-relative"
        style={{ height: "40vh", overflow: "hidden", margin: 0, padding: 0 }}
      >
        <img
          src={aboutimg}
          alt="Farm background"
          className="w-100 h-100"
          style={{ objectFit: "cover" }}
        />
        <div
          className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-start px-5"
          style={{
            background:
              "linear-gradient(to right, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0.1) 100%)",
          }}
        >
          <div className="text-start" style={{ maxWidth: 500, color: "#003333" }}>
            <h2 className="fw-bold fs-xxxl">Contact Us</h2>
          </div>
        </div>
      </section>

      {/* ⭐ PAGE CONTENT WITH PADDING */}
      <div style={styles.section}>
        <div style={styles.container}>

          {/* Left Column */}
          <div style={styles.column}>
            <h2 className="fs-xxxl fw-bold mb-4">Contact Info</h2>

            <div style={styles.infoGroup}>
              <div style={styles.label} className="fs-xl">Legal Name:</div>
              <div style={styles.value} className="fs-lg">Girorganic</div>
            </div>

            <div style={styles.infoGroup}>
              <div style={styles.label} className="fs-xl">Address:</div>
              <div style={styles.value} className="fs-lg">
                GirOrganic 132, Poonam Farm, Navi Pardi, Kamrej, Surat – 394150 GUJARAT, INDIA
              </div>
            </div>

            <div style={styles.infoGroup}>
              <div style={styles.label} className="fs-xl">Email:</div>
              <a href="mailto:info@girorganic.com" style={{ ...styles.value, ...styles.link }} className="fs-lg">
                info@girorganic.com
              </a>
            </div>

            <div style={styles.infoGroup}>
              <div style={styles.label} className="fs-xl">Phone:</div>
              <a href="tel:+919099909453" style={{ ...styles.value, ...styles.link }} className="fs-lg">
                +91-9099909453
              </a>{" "}
              <span className="fs-sm text-muted">(Monday - Saturday)</span>
            </div>

            <div style={styles.infoGroup}>
              <div style={styles.label} className="fs-xl">Whatsapp:</div>
              <a
                href="https://wa.me/919099909453"
                target="_blank"
                rel="noopener noreferrer"
                style={{ ...styles.value, ...styles.link }}
                className="fs-lg"
              >
                +91-9099909453
              </a>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div style={styles.column}>
            <h2 className="fs-xxxl fw-bold mb-4">Contact Form</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                style={styles.input}
                className="fs-sm"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <div style={styles.error} className="fs-sm">{errors.name}</div>}

              <input
                type="email"
                name="email"
                placeholder="Email *"
                style={styles.input}
                className="fs-sm"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <div style={styles.error} className="fs-sm">{errors.email}</div>}

              <input
                type="text"
                name="phone"
                placeholder="Phone number"
                style={styles.input}
                className="fs-sm"
                value={formData.phone}
                onChange={handleChange}
              />
              {errors.phone && <div style={styles.error} className="fs-sm">{errors.phone}</div>}

              <textarea
                name="comment"
                placeholder="Comment"
                rows="4"
                style={styles.textarea}
                className="fs-sm"
                value={formData.comment}
                onChange={handleChange}
              ></textarea>
              {errors.comment && <div style={styles.error} className="fs-sm">{errors.comment}</div>}

              <label style={styles.checkboxLabel} className="fs-sm">
                <input
                  type="checkbox"
                  name="terms"
                  checked={formData.terms}
                  onChange={handleChange}
                  style={styles.checkbox}
                />
                I agree to the{" "}
                <a href="#" className="text-decoration-underline">
                  Terms & Conditions
                </a>
              </label>
              {errors.terms && <div style={styles.error} className="fs-sm">{errors.terms}</div>}

              <button type="submit" style={styles.button} className="fs-sm">
                SEND
              </button>
            </form>
          </div>

        </div>
      </div>
    </div>
  );
}
